export default [
  {
    path: "/1354b8c1bb397211386c9195/:er?",
    name: "bece26.photoAlbum",
    component: () => import("@/views/bece/tws/photoalbum/index.vue"),
    meta: {
      title: "Print 2026 BECE PhotoAlbum",
      authRequired: true,
      acc: ["y37257"],
    },
  },
  {
    path: "/12700825845b4b68063e0dee",
    name: "bece26.photoAlbums",
    component: () => import("@/views/bece/tws/photoalbum/list.vue"),
    meta: {
      title: "2026 BECE PhotoAlbum",
      authRequired: true,
      acc: ["y51456"],
    },
  },
];
